import { axiosInstanceWithToken } from 'utils/axios';
import { IConfigurationRequestFetchRequest, IConfigurationRequestResource, IRFQEmail } from '../../server/types';

export const fetchConfigRequests = async (params?: IConfigurationRequestFetchRequest) =>
  axiosInstanceWithToken().get('configuration-requests', { params });

export const sendRfq = async (data: IRFQEmail) => axiosInstanceWithToken().post('configuration-requests/rfq', data);

export const createConfigRequest = async (data: IConfigurationRequestResource) =>
  axiosInstanceWithToken().post('configuration-requests', data);
